import { defaultResolvers, plugin } from '@marvr/storyblok-rich-text-vue-renderer'
import { NodeTypes } from '@marvr/storyblok-rich-text-types'
import TheLazy from '@/components/UI/TheLazy.vue'

const LazyTheMedia = defineAsyncComponent(() => import('@/storyblok/the-media/TheMedia.vue'))
const LazyTheImage = defineAsyncComponent(() => import('@/storyblok/the-image/TheImage.vue'))
const LazyTheHeader = defineAsyncComponent(() => import('@/storyblok/the-header/TheHeader.vue'))
const LazyYoutubeEmbed = defineAsyncComponent(() => import('@/storyblok/youtube-embed/YoutubeEmbed.vue'))
const LazyYoutubeEmbed2 = defineAsyncComponent(() => import('@/storyblok/youtube-embed-2/YoutubeEmbed2.vue'))
const LazyCardDownload = defineAsyncComponent(() => import('@/storyblok/card-download/CardDownload.vue'))
const LazyTable = defineAsyncComponent(() => import('@/storyblok/table/Table.vue'))
const LazyCard = defineAsyncComponent(() => import('@/storyblok/Card/Card.vue'))
const LazyVideo = defineAsyncComponent(() => import('@/storyblok/video/Video.vue'))
const LazyList = defineAsyncComponent(() => import('@/storyblok/UI/List.vue'))
const LazyBlockCard = defineAsyncComponent(() => import('@/storyblok/Card/BlockCard.vue'))

// Editors sometimes paste absolute links without "www" into rich text; those 301 to www and get
// flagged by SEO crawlers, so own-domain links are rendered as root-relative paths instead.
const OWN_DOMAIN_RE = /^https?:\/\/(?:www\.)?dexon-technology\.com(?=\/|$|[?#])/i

function toRelativeHref(href) {
  if (typeof href !== 'string' || !OWN_DOMAIN_RE.test(href))
    return href
  return href.replace(OWN_DOMAIN_RE, '') || '/'
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    plugin({
      resolvers: {
        ...defaultResolvers,
        [NodeTypes.IMAGE]: LazyTheImage,
        [NodeTypes.LINK]: props => defaultResolvers[NodeTypes.LINK]({
          ...props,
          attrs: { ...props.attrs, href: toRelativeHref(props.attrs?.href) },
        }),
        components: {
          'list': ({ fields }) => h(h(LazyList, { blok: { ...fields } })),
          'the-media': ({ fields }) => h(TheLazy, {}, h(LazyTheMedia, { blok: { ...fields } })),
          'the-header': ({ fields }) => h(h(LazyTheHeader, { blok: { ...fields } })),
          'youtube-embed': ({ fields }) => h(TheLazy, {}, h(LazyYoutubeEmbed, { blok: { ...fields } })),
          'youtube-embed-2': ({ fields }) => h(TheLazy, {}, h(LazyYoutubeEmbed2, { blok: { ...fields } })),
          'card-download': ({ fields }) => h(TheLazy, {}, h(LazyCardDownload, { blok: { ...fields } })),
          'table': ({ fields }) => h(TheLazy, {}, h(LazyTable, { blok: { ...fields } })),
          'card': ({ fields }) => h(LazyCard, { blok: { ...fields } }),
          'video': ({ fields }) => h(TheLazy, {}, h(LazyVideo, { blok: { ...fields } })),
          'block-card': ({ fields }) => h(LazyBlockCard, { blok: { ...fields }, embedded: true }),
        },
      },
    }),
  )
})
